import {Injectable} from '@angular/core';

import {
  StoreAssortment,
  StoreCampaign,
  StoreCardReleae,
  StoreCategoryShare,
  StoreCustomerRevenue,
  StoreEntry,
  StoreLoyaltyCustomerRevenue,
  StorePerformancePlot,
  StoreRevenueWeek
} from '../../models/store.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {Category, CategorySubsector, CategoryTree} from '../../models/category.model';
import {DatePipe} from '@angular/common';
import { PromoTypeAnalyticsModel } from '../../models/promo-type-analytics.model';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StoreCampaignService {

  private baseUrl = HttpClientService.BASE_MS_ANALYTICS;

  currentStore: StoreCampaign;
  categories: Category[];
  categories_subsectors: CategorySubsector[];
  subsectors_tree: CategoryTree[];
  currentStoreCustomerRevenue: StoreCustomerRevenue;
  currentStoreCardRelease: StoreCardReleae;
  flat_articles: CategorySubsector[];
  performance_plot: StorePerformancePlot[];
  revenue_week: StoreRevenueWeek[];
  loyalty_customer_revenue: StoreLoyaltyCustomerRevenue[];
  category_shares: StoreCategoryShare[];
  store_assortments: StoreAssortment[];
  store_list: StoreEntry[];

  public date_from: Date;
  public date_to: Date;
  public selectedStore: any;
  serie: any[];

  constructor (
    private h: HttpClientService,
    private datePipe: DatePipe
  ) { }

  get(id: number) {
    return this.h.get(this.baseUrl + '/stores/' + id)
      .map(res => {
        return this.currentStore = res;
      });
  }

  getStoreList() {
    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/list', {
      date_from: date_from_s,
      date_to: date_to_s
    }).map(res => {
      this.store_list = res;
    })
  }

  getStoreCustomerRevenue(store_id: number) {
    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/customer_revenue', {
      date_from: date_from_s,
      date_to: date_to_s,
      store_id: store_id
    })
      .map(res => {
        this.currentStoreCustomerRevenue = res;

      });
  }

  getStoreCardRelease(store_id: number) {
    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/card_release', {
      date_from: date_from_s,
      date_to: date_to_s,
      store_id: store_id
    })
      .map(res => {
        this.currentStoreCardRelease = res;

      });
  }

  getPerformancePlot() {
    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/performance_plot', {
      date_from: date_from_s,
      date_to: date_to_s
    })
      .map(res => {
        return this.performance_plot = res;

      });

  }

  getListPDV(data: any) {
    return this.h.post(this.baseUrl + '/analytics/getDataSerie/stores.Q075', data).map(res => {
      this.serie = [];
      for (let j = 0; j < res.series[0].serie.length; j++) {
        const temp = {};
        for (let i = 0; i < res.series.length; i++) {
          console.log(res.series[i].titolo + ': ' + res.series[i].serie[j]);
          temp[res.series[i].titolo] = res.series[i].serie[j];
        }
        console.log(temp);

        temp['revenueUom'] = this._getUom(temp['revenue']);
        temp['revenue'] = this._formatDynamic(temp['revenue']);

        this.serie.push(temp);
      }
      this.store_list = this.serie;
    })
  }

  getRevenueWeek() {

    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/revenue_week', {
      store_code: this.selectedStore,
      date_from: date_from_s,
      date_to: date_to_s
    })
      .map(res => {
        return this.revenue_week = res;

      });
  }

  getLoyaltyCustomerRevenue() {
    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/loyalty_customer_revenue', {
      store_code: this.selectedStore,
      date_from: date_from_s,
      date_to: date_to_s
    })
      .map(res => {
        return this.loyalty_customer_revenue = res;

      });
  }

  getCategoryShare() {
    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/category_share', {
      store_code: this.selectedStore,
      date_from: date_from_s,
      date_to: date_to_s
    })
      .map(res => {
        return this.category_shares = res;

      });
  }

  getAssortment() {
    const date_from_s: string = this.datePipe.transform(this.date_from, 'yyyy-MM-dd');
    const date_to_s: string = this.datePipe.transform(this.date_to, 'yyyy-MM-dd');

    return this.h.post(this.baseUrl + '/stores/store_assortment', {
      store_code: this.selectedStore,
      date_from: date_from_s,
      date_to: date_to_s
    })
      .map(res => {
        return this.store_assortments = res;

      });
  }


  getCategories() {
    this.categories = [];
    this.categories_subsectors = [];
    this.subsectors_tree = [];
    return this.h.get(this.baseUrl + '/stores/categories')
      .map(res => {
        return this.categories = res;
      });
  }

  getCategoryArticles(category: string) {
    return this.h.post(this.baseUrl + '/stores/categories/subsectors', {category: category})
      .map(res => {
        return this.flat_articles = res;
      });
  }

  getSubsectorsTree(category: string) {
    return this.h.post(this.baseUrl + '/stores/categories/subsectors', {category: category})
      .map(res => {
        this.subsectors_tree = [];
        res.forEach(entry => this._buildTree(entry));

        return this.subsectors_tree;
      });
  }

  getCategorySubsectors(category: string) {
    return this.h.post(this.baseUrl + '/stores/categories/subsectors', {category: category})
      .map(res => {
        this.subsectors_tree = [];
        res.forEach(entry => this._buildTree(entry));

        console.log('tree', this.subsectors_tree);

        return this.categories_subsectors = res;
      });
  }

  getAnalyticsPromoList(): Observable<PromoTypeAnalyticsModel[]> {
    return this.h.get(this.baseUrl + '/analytics/getPromo');
  }

  private _buildTree(entry) {
    let subsector: CategoryTree = this.subsectors_tree.find(s => s.data.id === entry['codice_subsettore']);
    if (subsector == null) {
      subsector = {
        data: {
          id: entry['codice_subsettore'],
          description: entry['descrizione_subsettore']
        },
        children: []
      };
      this.subsectors_tree.push(subsector);
    }

    let division: CategoryTree = subsector.children != null ? subsector.children.find(e => e.data.id === entry['codice_reparto']) : null;
    if (division == null) {
      division = {
        data: {
          id: entry['codice_reparto'],
          description: entry['descrizione_reparto']
        },
        children: []
      };
      subsector.children.push(division);
    }

    let categ: CategoryTree = division.children != null ? division.children.find(e => e.data.id === entry['codice_categoria']) : null;
    if (categ == null) {
      categ = {
        data: {
          id: entry['codice_categoria'],
          description: entry['descrizione_categoria']
        },
        children: []
      };
      division.children.push(categ);
    }

    let subcategory: CategoryTree = categ.children != null ? categ.children.find(e => e.data.id === entry['codice_subcategoria']) : null;
    if (subcategory == null) {
      subcategory = {
        data: {
          id: entry['codice_subcategoria'],
          description: entry['descrizione_subcategoria']
        },
        children: []
      };
      categ.children.push(subcategory);
    }

    let family: CategoryTree = subcategory.children != null ? subcategory.children.find(e => e.data.id === entry['codice_famiglia']) : null;
    if (family == null) {
      family = {
        data: {
          id: entry['codice_famiglia'],
          description: entry['descrizione_famiglia']
        },
        children: []
      };
      subcategory.children.push(family);
    }

    let subfamily: CategoryTree = family.children != null ? family.children.find(e => e.data.id === entry['codice_subfamiglia']) : null;
    if (subfamily == null) {
      subfamily = {
        data: {
          id: entry['codice_subfamiglia'],
          description: entry['descrizione_subfamiglia']
        },
        children: []
      };
      family.children.push(subfamily);
    }

    // TODO riativare in caso "revoca" del KS-373 (I3 ref T3784)
    /*let article: CategoryTree = subfamily.children != null ? subfamily.children.find(e => e.data.id === entry['codice_articolo']) : null;
    if (article == null) {
      article = {
        data: {
          id: entry['codice_articolo'],
          description: entry['descrizione_articolo']
        },
        children: []
      };

      subfamily.children.push(article);
    }*/
  }

  private _formatDynamic(x: number): number {
    switch (true) {
      case +x >= 1000000:
        return (x / 1000000);
      case +x >= 1000:
        return x / 1000;
      default:
        return x;
    }
  }

  private _getUom(x: number): string {
    switch (true) {
      case +x >= 1000000:
        return 'M';
      case +x >= 1000:
        return 'K';
      default:
        return '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/store/stores-campaign.service.ts